import type { OrderStatus } from '../types'

export function formatElapsed(seconds: number) {
  const safe = Math.max(0, Math.floor(seconds))
  const mins = Math.floor(safe / 60).toString().padStart(2, '0')
  const secs = (safe % 60).toString().padStart(2, '0')
  return `${mins}:${secs}`
}

export function elapsedSince(date: string) {
  return Math.max(0, Math.floor((Date.now() - new Date(date).getTime()) / 1000))
}

export function StatusPill({ status }: { status: string | OrderStatus }) {
  const normalized = status.replaceAll('_', ' ')
  return <span className={`status-pill status-${status}`}>{normalized}</span>
}
